import { SaveForLaterSlideInPanelAnchorLocation } from "@redotech/redo-customer-accounts-common/save-for-later-slide-in-panel-anchor-location";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const updateSaveForLaterStorefrontDisplaySettings = {
  name: "updateSaveForLaterStorefrontDisplaySettings" as const,
  input: z.object({
    teamId: z.string(),
    enabled: z.boolean(),
    title: z.string(),
    message: z.string(),
    numViewedProductsUntilPanelOpen: z.number(),
    anchorLocation: createEnum(SaveForLaterSlideInPanelAnchorLocation),
  }),
  output: z.null(),
};
